'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getConfiguration = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.fetchConfigurationSaga = fetchConfigurationSaga;
exports.watchGetConfiguration = watchGetConfiguration;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _api = require('helpers/api');

var _api2 = _interopRequireDefault(_api);

var _fetchEntitySagaAuth = require('../../utils/fetchEntitySagaAuth');

var _fetchEntitySagaAuth2 = _interopRequireDefault(_fetchEntitySagaAuth);

var _notifications = require('../notifications');

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchConfigurationSaga),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchGetConfiguration);
// import getConfiguration from 'oldCFA'


var uuidV4 = _uuid2.default.v4;

var GET_CONFIGURATION = {
    BASE: 'tq-plus-admin/genericSettings/oldCFA/GET_CONFIGURATION.BASE',
    REQUEST: 'tq-plus-admin/genericSettings/oldCFA/GET_CONFIGURATION.REQUEST',
    SUCCESS: 'tq-plus-admin/genericSettings/oldCFA/GET_CONFIGURATION.SUCCESS',
    FAILURE: 'tq-plus-admin/genericSettings/oldCFA/GET_CONFIGURATION.FAILURE'
};

var getConfiguration = exports.getConfiguration = {
    base: function base(codedToken) {
        return {
            type: GET_CONFIGURATION.BASE,
            url: 'webservice-settings/get-webservice-settings',
            token: codedToken
        };
    },
    request: function request() {
        return { type: GET_CONFIGURATION.REQUEST };
    },
    success: function success(configuration) {
        return { type: GET_CONFIGURATION.SUCCESS, payload: configuration };
    },
    failure: function failure(error) {
        return { type: GET_CONFIGURATION.FAILURE, error: error };
    }
};

function fetchConfigurationSaga(_ref) {
    var url = _ref.url,
        token = _ref.token;
    var result;
    return _regenerator2.default.wrap(function fetchConfigurationSaga$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(function () {
                        return (0, _fetchEntitySagaAuth2.default)(getConfiguration, _api2.default.get, url, { token: token });
                    });

                case 3:
                    result = _context.sent;
                    return _context.abrupt('return', result);

                case 7:
                    _context.prev = 7;
                    _context.t0 = _context['catch'](0);
                    _context.next = 11;
                    return (0, _effects.put)((0, _notifications.error)({
                        title: 'Error retrieving configuration',
                        message: _context.t0.message
                    }));

                case 11:
                    throw _context.t0;

                case 12:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 7]]);
}

function watchGetConfiguration() {
    return _regenerator2.default.wrap(function watchGetConfiguration$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _reduxSaga.takeLatest)(GET_CONFIGURATION.BASE, fetchConfigurationSaga);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/GenericSettings/configSaga.js
// module id = 1655
// module chunks = 0